import {
  FacebookShareButton,
  FacebookIcon,
  WhatsappShareButton,
  WhatsappIcon,
  TwitterShareButton,
  TwitterIcon,
  TelegramShareButton,
  TelegramIcon,
  FacebookMessengerIcon,
  EmailShareButton,
  EmailIcon
} from 'react-share'

import React from 'react'

import { SocialIcon } from 'react-social-icons'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { Button, Modal, ModalHeader, ModalBody, Row, Col } from 'reactstrap'
import { getFormattedDateTime, firstLetter } from 'common'
import { isMobile } from 'react-device-detect'
import { ListingsApi } from 'typescript-axios'
import classNames from 'classnames'
import { getAxiosParams } from '../utils/client'
import { UserContext } from '../contexts/UserContext'
import MessengerShareButton from './MessengerShareButton'
import useTranslation from '../hooks/UseTranslation'

const LISTINGS_SERVICE = new ListingsApi(getAxiosParams())

const FB_APP_ID = '897557035697412'

const ShareModal = ({ isOpen, toggle, ...props }) => {
  const { t } = useTranslation()
  const [hasCopied, setHasCopied] = React.useState(false)
  const [instaLoading, setInstaLoading] = React.useState(false)
  const [instaImage, setInstaImage] = React.useState()
  const [showInstaHint, setShowInstaHint] = React.useState(false)
  const { loggedUser } = React.useContext(UserContext)
  const { listing, retreat, user } = props

  if (user && !user.is_guru) return <div />

  let shareUrl = null
  let title = ''
  if (props.shareUrl) {
    shareUrl = props.shareUrl
    title = t('share_modal_title_for_guru_code')
  } else if (listing) {
    const isOwner = listing.owner.id == loggedUser?.id
    shareUrl = `${process.env.NEXT_PUBLIC_HOST}/classes/${listing.slug}`
    const { date } = getFormattedDateTime(listing.datetime_start)
    if (isOwner) {
      shareUrl += `?code=${loggedUser.guru_code}`
      title = t(
        'share_modal_title_for_class_as_owner',
        listing.activity.name,
        date
      )
    } else {
      title = t(
        'share_modal_title_for_class',
        listing.activity.name,
        listing.owner.name_display,
        date
      )
    }
  } else if (retreat) {
    const isOwner = retreat.owner.id == loggedUser?.id
    shareUrl = `${process.env.NEXT_PUBLIC_HOST}/retreats/${retreat.slug}`
    const { date } = getFormattedDateTime(retreat.datetime_start)
    if (isOwner) {
      shareUrl += `?code=${loggedUser.guru_code}`
      title = t('share_modal_title_for_retreat_as_owner', date)
    } else {
      title = t(
        'share_modal_title_for_retreat',
        retreat.activities[0].name,
        retreat.owner.name_display,
        date
      )
    }
  } else if (user) {
    const activity = user.activities[0].name
    if (user.id == loggedUser?.id) {
      shareUrl = `${process.env.NEXT_PUBLIC_HOST}/u/${loggedUser.guru_code}`
      title = t('share_modal_title_for_profile_as_owner')
    } else {
      shareUrl = `${process.env.NEXT_PUBLIC_HOST}/@${user.slug}`
      title = t('share_modal_title_for_profile', user.name_display, activity)
    }
  }
  title = firstLetter(title)

  const style = {
    display: 'inline-block',
    marginRight: '10px',
    textAlign: 'center'
  }
  const size = 32
  const hashtag = t('share_modal_hashtag')
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        {props.header ?? t('share_modal_header')}
      </ModalHeader>
      <ModalBody>
        {props.content && <p>{props.content}</p>}
        {props.children}
        {isMobile && showInstaHint && <p>{t('share_modal_insta_hint')}</p>}
        {instaImage && (
          <div className='text-center p-4'>
            <img src={instaImage} style={{ maxWidth: '50%' }} />
          </div>
        )}
        <Row>
          <Col lg='7' className='d-flex align-items-center'>
            {isMobile && listing && listing.owner.id == loggedUser?.id && (
              <SocialIcon
                network='instagram'
                style={{
                  ...style,
                  height: size,
                  width: size,
                  cursor: 'pointer'
                }}
                onClick={() => {
                  if (instaLoading) return
                  setInstaLoading(true)
                  setShowInstaHint(true)
                  LISTINGS_SERVICE.getInstaShareApiV1ListingsInstaShareListingSlugGet(
                    listing.slug,
                    { responseType: 'arraybuffer' }
                  )
                    .then((res) => {
                      const [, filename] =
                        res.headers['content-disposition'].split('filename=')
                      const blob = new Blob([res.data], { type: 'image/jpeg' })
                      const reader = new FileReader()
                      reader.readAsDataURL(blob)
                      reader.onloadend = function () {
                        const base64data = reader.result
                        setInstaImage(base64data)
                      }
                      // const link = document.createElement('a')
                      // link.href = window.URL.createObjectURL(blob)
                      // link.download = filename.replace(/"/g, "")
                      // link.click()
                    })
                    .finally(() => setInstaLoading(false))
                }}
              />
            )}
            <FacebookShareButton
              style={style}
              url={shareUrl}
              quote={title}
              hashtag={`#${hashtag}`}
            >
              <FacebookIcon size={size} round />
            </FacebookShareButton>
            <MessengerShareButton
              mobile={isMobile}
              style={style}
              url={shareUrl}
              appId={FB_APP_ID}
            >
              <FacebookMessengerIcon size={size} round />
            </MessengerShareButton>
            <WhatsappShareButton
              style={style}
              url={shareUrl}
              title={title}
              separator=' '
            >
              <WhatsappIcon size={size} round />
            </WhatsappShareButton>
            <TwitterShareButton
              style={style}
              url={shareUrl}
              title={title}
              hashtags={[hashtag]}
            >
              <TwitterIcon size={size} round />
            </TwitterShareButton>
            <TelegramShareButton style={style} url={shareUrl} title={title}>
              <TelegramIcon size={size} round />
            </TelegramShareButton>
            <EmailShareButton
              style={style}
              url={shareUrl}
              subject={title}
              body={title}
            >
              <EmailIcon size={size} round />
            </EmailShareButton>
          </Col>
          <Col lg='5' className='text-right'>
            <CopyToClipboard
              text={shareUrl}
              onCopy={() => {
                setHasCopied(true)
                setTimeout(() => setHasCopied(false), 2000)
              }}
            >
              <Button
                color='link'
                disabled={hasCopied}
                className='pl-0 text-primary collapsed'
              >
                {hasCopied ? t('share_modal_copied') : t('share_modal_copy')}
              </Button>
            </CopyToClipboard>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  )
}

export const ShareProfileCta = ({
  user,
  listing,
  retreat,
  className,
  children
}) => {
  const { t } = useTranslation()
  const [showShareModal, setShowShareModal] = React.useState(false)
  const onClick = (e) => {
    e.preventDefault()
    setShowShareModal(true)
  }

  // key necessary because FA icon does not rerender, do not remove
  const label = (
    <>
      <i key={Math.random()} className='fa fa-share-alt fa-fw mr-2' />
      {t('share')}
    </>
  )

  return (
    <div>
      <ShareModal
        isOpen={showShareModal}
        toggle={() => setShowShareModal(!showShareModal)}
        user={user}
        listing={listing}
        retreat={retreat}
      />
      {children ? (
        children(onClick, label)
      ) : (
        <Button
          color='link'
          className={classNames('p-0 text-sm mb-2', className, {
            'text-secondary': !className
          })}
          id='share'
          onClick={onClick}
        >
          {label}
        </Button>
      )}
    </div>
  )
}

export default ShareModal
